export default function OptimizerCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSJyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl lg:text-5xl font-bold mb-6">
          准备好优化您的PDF文档了吗？
        </h2>
        <p className="text-xl text-gray-300 mb-12 leading-relaxed">
          立即下载免费试用版，体验PDF Optimizer的强大功能
        </p>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 mb-8">
          <h3 className="text-2xl font-bold mb-6">安装步骤</h3>
          <div className="grid md:grid-cols-5 gap-6 text-left">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-3 text-xl font-bold">1</div>
              <div className="text-sm">填写表单获取激活密钥</div>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-3 text-xl font-bold">2</div>
              <div className="text-sm">复制激活密钥</div>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-3 text-xl font-bold">3</div>
              <div className="text-sm">下载软件</div>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-3 text-xl font-bold">4</div>
              <div className="text-sm">运行安装文件</div>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-3 text-xl font-bold">5</div>
              <div className="text-sm">粘贴激活密钥</div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="/contact" 
            className="inline-flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span className="iconify i-material-symbols:download w-5 h-5 mr-2" aria-hidden="true"></span>
            下载免费试用
          </a>
          <a 
            href="/contact" 
            className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 border border-white/20 whitespace-nowrap cursor-pointer"
          >
            <span className="iconify i-material-symbols:contact-support w-5 h-5 mr-2" aria-hidden="true"></span>
            联系销售
          </a>
        </div>
      </div>
    </section>
  );
}
